/**
 * A função transforma o objeto obtido, como:
 *   {
 *      comissao: {
 *         listagem: {
 *           codigo: 'Código'
 *         }
 *      }
 *   }
 *
 * em:
 *   {
 *      'comissao.listagem.codigo': 'Código'
 *   }
 *
 * para que seja passado para o Intl e o mesmo compreenda o caminho da mensagem
 */
export const flattenMessages = (nestedMessages, prefix = '') => {
  if (!nestedMessages) return {};

  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      Object.assign(messages, { [prefixedKey]: value });
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
};
